<form [formGroup]="descriptionForm">
    <div class="row">
        <div class="col s12" style="padding-top:15px;">
            <app-input [formControl]="descriptionForm.controls.name"
                       [showErrors]="showValidations"
                       label="{{'admin.tools.form.labels.name' | translate}}">
            </app-input>
            <app-textarea [formControl]="descriptionForm.controls.description"
                          [showErrors]="showValidations"
                          [maxLength]="120"
                          [label]="'intervention-modal.description.label' | translate"
                          [placeholder]="'intervention-modal.description.placeholder' | translate">
            </app-textarea>
            <app-dropdown-autocomplete
                [formControl]="descriptionForm.controls.codingType"
                [items]="codingTypeOptions"
                [useObjects]="true"
                displayField="label"
                valueField="value"
                [appendTo]="'body'"
                [showErrors]="showValidations"
                [label]="'admin.tools.form.labels.codingType' | translate"
                [emptyText]="'admin.tools.form.labels.codingType' | translate">
            </app-dropdown-autocomplete>
            <app-input [formControl]="descriptionForm.controls.mesCode"
                       [showErrors]="showValidations || descriptionForm.controls.mesCode.dirty"
                       [isReadonly]="isToolCodeReadonly()"
                       placeholder="{{'admin.tools.form.labels.toolCode' | translate }}"
                       label="{{'admin.tools.form.labels.toolCode' | translate }}">
            </app-input>
            <div *ngIf="isToolCodeAutoGenerated()" class="tool-code-generated-message">
                {{ 'admin.tools.form.messages.toolCodeAutoGeneratedFromToolUid' | translate }}
            </div>
            <button
                *ngIf="canReopenInfoModal()"
                type="button"
                class="info-modal-reopen"
                (click)="reopenInfoModal()"
                [title]="'validation.toolCode.infoModal.title' | translate">
                <i class="material-icons">warning</i>
            </button>
            <app-input [formControl]="descriptionForm.controls.toolControlName"
                       [showErrors]="showValidations"
                       placeholder="{{'admin.tools.form.labels.toolControlName' | translate }}"
                       label="{{'admin.tools.form.labels.toolControlName' | translate }}">
            </app-input>
            <app-input class="input-id-set" [formControl]="descriptionForm.controls.idFromSet"
                       [showErrors]="showValidations"
                       [label]="'admin.tools.details.detailsPage.labels.toolNumber' | translate">
            </app-input>
            <app-input [formControl]="descriptionForm.controls.supplierCode"
                        [showErrors]="showValidations"
                        placeholder="{{'admin.tools.form.labels.supplierCode' | translate }}"
                        label="{{'admin.tools.form.labels.supplierCode' | translate }}">
            </app-input>
            <app-input [formControl]="descriptionForm.controls.inventoryNumber"
                        [showErrors]="showValidations"
                        placeholder="{{'admin.tools.form.labels.inventoryNumber' | translate }}"
                        label="{{'admin.tools.form.labels.inventoryNumber' | translate }}">
            </app-input>
            <app-dropdown-autocomplete [formControl]="descriptionForm.controls.owner"
                                       [showErrors]="showValidations"
                                       [items]="owners"
                                       [useObjects]="true"
                                       [appendTo]="'body'"
                                       [resetSelectionOnItemChange]="false"
                                       [label]="'admin.tools.form.labels.owner.label' | translate"
                                       [emptyText]="'admin.tools.form.labels.owner.placeholder' | translate">

            </app-dropdown-autocomplete>
            <app-input-switch [formControl]="descriptionForm.controls.isSpare"
                              offLabel="{{'admin.tools.details.detailsPage.labels.isSpare' | translate }}">
            </app-input-switch>
        </div>
    </div>
</form>
<app-tool-property-validation-info-modal
    #infoModal
    [title]="'validation.toolCode.infoModal.title' | translate"
    [message]="'validation.toolCode.infoModal.message' | translate"
    [tools]="infoModalTools"
    (confirm)="onInfoConfirm()">
</app-tool-property-validation-info-modal>
